import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only z-50 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground focus:not-sr-only focus:fixed focus:top-3 focus:left-3'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
